import { useState } from 'react';
import LegalModal, { type LegalKind } from '../share/ui/LegalModal';
import { useUserMenuPresent } from '@/lib/user-menu-presence';

/**
 * Task #136 — Impressum / Datenschutz footer for the admin/internal app.
 * TMG § 5 requires the Impressum to be reachable from every page, so this
 * mounts at the app root. Task #140: while LOGGED IN the fixed footer is
 * hidden (the chat dock covered it at the bottom edge) — the links live at
 * the bottom of the user menu instead. Logged out (e.g. /login, which has
 * no user menu) the footer remains, keeping the public page compliant.
 * Reuses the shared LegalModal from the client share pages; the modal's
 * `.legal-*` classes are styled for the admin app in index.css because
 * share.css is not loaded here.
 */
export function LegalFooter() {
  const [open, setOpen] = useState<LegalKind | null>(null);
  const menuPresent = useUserMenuPresent();

  // A mounted UserMenu carries the legal links — hide the fixed footer
  // there. On pages WITHOUT a user menu (login, transcript admin pages,
  // …) the footer stays so the legal texts remain reachable everywhere.
  if (menuPresent) {
    return open ? <LegalModal kind={open} surface="app" onClose={() => setOpen(null)} /> : null;
  }

  return (
    <>
      <footer className="admin-legal-footer" data-testid="legal-footer">
        <button
          type="button"
          className="admin-legal-link"
          onClick={() => setOpen('impressum')}
          data-testid="link-impressum"
        >
          Impressum
        </button>
        <span className="admin-legal-sep" aria-hidden="true">·</span>
        <button
          type="button"
          className="admin-legal-link"
          onClick={() => setOpen('datenschutz')}
          data-testid="link-datenschutz"
        >
          Datenschutz
        </button>
      </footer>
      {open && <LegalModal kind={open} surface="app" onClose={() => setOpen(null)} />}
    </>
  );
}
